import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listReservationTypes = (customerId) => {
  let urlString = ``;
  if (customerId) {
    urlString += `&customerId=${customerId}`;
  }
  return axios.get(
    `${getV1RootUrl()}/reservation-type/for-web?${urlString}`,
    publicAxiosHeader()
  );
};

export const getReservationType = (slug, customerId) => {
  let urlString = ``;
  if (customerId) {
    urlString += `&customerId=${customerId}`;
  }
  return axios.get(
    `${getV1RootUrl()}/reservation-type/slug/${slug}/for-web?${urlString}`,
    publicAxiosHeader()
  );
};
